import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["token", "refresh", "encryption", "publicKey", "aesFileEncryptionKey", "ivFileEncryptionKey"];
import _regeneratorRuntime from "@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { stringify } from 'query-string';
import fetchJson from './fetchJson';
import { GET_ONE, GET_LIST, GET_MANY, GET_MANY_REFERENCE, CREATE, CREATE_MANY, UPLOAD, PATCH, UPDATE, UPDATE_MANY, UPDATE_MANY_POST, DELETE, DELETE_MANY, DELETE_MANY_POST, SET_ITEM, SET_ITEMS, SEARCH_ADDRESS, REVERSE_ADDRESS, AUTH, REVERT, DOWNLOAD, UPLOAD_MANY } from '../../actions/constants';
import EncryptionService from '../encryption';
import HttpError from './HttpError';
import get from '../../utils/get';
import { anonymizeObject } from '../../utils/tools';
export { default as HttpError } from './HttpError';

var concatMultiplesResponses = function concatMultiplesResponses(responses) {
  return {
    data: responses.map(function (response) {
      return response.json;
    }),
    header: responses.pop().headers
  };
};

export var convertDataRequestToHTTP = function convertDataRequestToHTTP(apiUrl, originalType, resource, originalParams, chunkId, chunkResource) {
  var type = originalType.split('/')[0];
  var url = '';
  var options = {
    headers: {
      'Content-Type': 'application/json'
    }
  };

  var params = _objectSpread({}, originalParams);

  switch (type) {
    case GET_LIST:
      {
        params.limit = params.limit || 200;
        params.page = params.page || 0;
        url = "".concat(apiUrl, "/").concat(resource).concat(chunkId ? "/".concat(chunkId) : '').concat(chunkResource ? "/".concat(chunkResource) : '', "?").concat(stringify(params));
        break;
      }

    case GET_ONE:
      {
        var id = params.id,
            rest = params.params;
        var baseUrl = "".concat(apiUrl, "/").concat(resource);
        url = baseUrl;

        if (id) {
          url = "".concat(url, "/").concat(id).concat(chunkResource ? "/".concat(chunkResource) : '');
        } else if (chunkResource) {
          url = "".concat(url, "/").concat(chunkResource);
        }

        if (rest) {
          url = "".concat(url, "?").concat(stringify(rest));
        }

        break;
      }

    case GET_MANY:
      {
        url = "".concat(apiUrl, "/").concat(resource).concat(chunkResource ? "/".concat(chunkResource) : '', "?").concat(stringify(params));
        break;
      }

    case GET_MANY_REFERENCE:
      {
        var _params$pagination2 = params.pagination,
            page = _params$pagination2.page,
            perPage = _params$pagination2.perPage;
        var _params$sort2 = params.sort,
            field = _params$sort2.field,
            order = _params$sort2.order;
        var query = {
          sort: JSON.stringify([field, order]),
          range: JSON.stringify([(page - 1) * perPage, page * perPage - 1]),
          filter: JSON.stringify(_objectSpread(_objectSpread({}, params.filter), {}, _defineProperty({}, params.target, params.id)))
        };
        url = "".concat(apiUrl, "/").concat(resource, "?").concat(stringify(query));
        break;
      }

    case PATCH:
    case UPDATE:
      url = "".concat(apiUrl, "/").concat(resource).concat(params.id ? "/".concat(params.id) : '').concat(chunkId ? "/".concat(chunkId) : '').concat(chunkResource ? "/".concat(chunkResource) : '', "?").concat(stringify(params.params));
      options = _objectSpread(_objectSpread({}, options), {}, {
        method: type === UPDATE ? 'PUT' : 'PATCH',
        body: JSON.stringify(params.data)
      });
      break;

    case UPDATE_MANY_POST:
      url = "".concat(apiUrl, "/").concat(resource).concat(chunkId ? "/".concat(chunkId) : '').concat(chunkResource ? "/".concat(chunkResource) : '', "?").concat(stringify(params.params));
      options = _objectSpread(_objectSpread({}, options), {}, {
        method: 'POST',
        body: JSON.stringify(params.items)
      });
      break;

    case REVERT:
    case CREATE:
      url = "".concat(apiUrl, "/").concat(resource).concat(chunkId ? "/".concat(chunkId) : '').concat(chunkResource ? "/".concat(chunkResource) : '', "?").concat(stringify(params.params));
      options = _objectSpread(_objectSpread({}, options), {}, {
        method: 'POST',
        body: JSON.stringify(params.data)
      });
      break;

    case UPLOAD:
      {
        var _params$data;

        var fd = new FormData();
        Object.keys((_params$data = params === null || params === void 0 ? void 0 : params.data) !== null && _params$data !== void 0 ? _params$data : {}).forEach(function (key) {
          fd.append(key, params.data[key]);
        });
        url = "".concat(apiUrl, "/").concat(resource).concat(chunkId ? "/".concat(chunkId) : '').concat(chunkResource ? "/".concat(chunkResource) : '', "?").concat(stringify(params.params));
        options = _objectSpread(_objectSpread({}, options), {}, {
          // unset content-type so it gets transformed into form-data by the browser
          headers: _objectSpread(_objectSpread({}, options.headers), {}, {
            'Content-Type': null
          }),
          method: 'POST',
          body: fd
        });
        break;
      }

    case UPLOAD_MANY:
      {
        var _params$data2;

        var _fd = new FormData();

        Object.keys((_params$data2 = params === null || params === void 0 ? void 0 : params.data) !== null && _params$data2 !== void 0 ? _params$data2 : {}).forEach(function (key) {
          if (Array.isArray(params === null || params === void 0 ? void 0 : params.data[key]) && params !== null && params !== void 0 && params.data[key].some(function (file) {
            return file instanceof File;
          })) {
            params.data[key].forEach(function (item) {
              _fd.append(key, item);
            });
          } else {
            _fd.append(key, params.data[key]);
          }
        });
        url = "".concat(apiUrl, "/").concat(resource).concat(chunkId ? "/".concat(chunkId) : '').concat(chunkResource ? "/".concat(chunkResource) : '', "?").concat(stringify(params.params));
        options = _objectSpread(_objectSpread({}, options), {}, {
          // unset content-type so it gets transformed into form-data by the browser
          headers: _objectSpread(_objectSpread({}, options.headers), {}, {
            'Content-Type': null
          }),
          method: 'POST',
          body: _fd
        });
        break;
      }

    case DOWNLOAD:
      {
        params.limit = params.limit || 200;
        params.page = params.page || 0;
        url = "".concat(apiUrl, "/").concat(resource).concat(chunkId ? "/".concat(chunkId) : '').concat(chunkResource ? "/".concat(chunkResource) : '', "?").concat(stringify(params));
        options = _objectSpread(_objectSpread({}, options), {}, {
          headers: _objectSpread(_objectSpread({}, options.headers), {}, {
            'Content-Type': null,
            Accept: null
          }),
          responseType: 'blob',
          method: 'GET'
        });
        break;
      }

    case DELETE:
      url = "".concat(apiUrl, "/").concat(resource, "/").concat(params.id ? params.id : '').concat(chunkResource ? "/".concat(chunkResource) : '', "?").concat(stringify(params.params));
      options = _objectSpread(_objectSpread({}, options), {}, {
        method: 'DELETE'
      });
      break;

    case DELETE_MANY_POST:
      url = "".concat(apiUrl, "/").concat(resource).concat(chunkId ? "/".concat(chunkId) : '').concat(chunkResource ? "/".concat(chunkResource) : '', "?").concat(stringify(params.params));
      options = _objectSpread(_objectSpread({}, options), {}, {
        method: 'POST',
        body: JSON.stringify(params.ids)
      });
      break;

    case AUTH:
      url = "".concat(apiUrl, "/").concat(resource);
      options = _objectSpread(_objectSpread({}, options), {}, {
        method: 'POST',
        body: JSON.stringify(params.data)
      });
      break;

    case REVERSE_ADDRESS:
    case SEARCH_ADDRESS:
      url = "".concat(apiUrl, "/").concat(resource, "?").concat(stringify(params));
      options = _objectSpread(_objectSpread({}, options), {}, {
        headers: _objectSpread(_objectSpread({}, options.headers), {}, {
          'Content-Type': null
        })
      });
      break;

    case SET_ITEM:
      url = null;
      options = null;
      break;

    case SET_ITEMS:
      url = null;
      options = null;
      break;

    default:
      throw new Error("Unsupported fetch action type ".concat(type));
  }

  return {
    url: url,
    options: options
  };
};
/**
 *
 * The REST dialect is similar to the one of FakeRest
 * @see https://github.com/marmelab/FakeRest
 * @example
 * GET_ONE      => GET http://my.api.url/posts/123
 * GET_LIST     => GET http://my.api.url/posts?sort=['title','ASC']&range=[0, 24]
 * GET_MANY     => GET http://my.api.url/posts?filter={ids:[123,456,789]}
 * UPDATE       => PUT http://my.api.url/posts/123
 * CREATE       => POST http://my.api.url/posts
 * DELETE       => DELETE http://my.api.url/posts/123
 */

var runQuery = function runQuery(apiUrl) {
  var httpOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var encryptionService = arguments.length > 2 ? arguments[2] : undefined;
  var httpClient = fetchJson(_objectSpread(_objectSpread({}, httpOptions), {}, {
    apiUrl: apiUrl
  }), encryptionService);
  /**
   * @param {Object} response HTTP response from fetch()
   * @param {String} type One of the constants appearing at the top if this file, e.g. 'UPDATE'
   * @param {String} resource Name of the resource to fetch, e.g. 'posts'
   * @param {Object} params The data request params, depending on the type
   * @returns {Object} Data response
   */

  var convertHTTPResponse = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(response, type, resource, params) {
      var status, statusText, headers, data, originalJSON, aesKey, token, refresh, keyId, iv, contentType, json, _token, _refresh;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            status = response.status, statusText = response.statusText, headers = response.headers, data = response.data, originalJSON = response.json;

            if (!encryptionService) {
              _context.next = 7;
              break;
            }

            _context.next = 4;
            return encryptionService.getAESKey();

          case 4:
            _context.t0 = _context.sent;
            _context.next = 8;
            break;

          case 7:
            _context.t0 = null;

          case 8:
            aesKey = _context.t0;

            /**
             * Be careful, fetch sends lower case header
             * https://stackoverflow.com/questions/34656412/fetch-sends-lower-case-header-keys
             */
            token = headers.get('authorization');
            refresh = headers.get('refresh');
            keyId = headers.get('key-id');
            iv = headers.get('iv');
            contentType = headers.get('content-type'); // const { cipher } = originalJSON || {};

            if (!(data && iv && aesKey)) {
              _context.next = 20;
              break;
            }

            _context.next = 17;
            return EncryptionService.decodeCipher(!(contentType !== null && contentType !== void 0 && contentType.includes('application/json')) ? params.aesFileEncryptionKey : aesKey, !(contentType !== null && contentType !== void 0 && contentType.includes('application/json')) ? params.ivFileEncryptionKey : iv, data, contentType);

          case 17:
            _context.t1 = _context.sent;
            _context.next = 21;
            break;

          case 20:
            _context.t1 = originalJSON || data;

          case 21:
            json = _context.t1;

            if (!(iv && token && aesKey)) {
              _context.next = 28;
              break;
            }

            _context.next = 25;
            return EncryptionService.decodeCipher(aesKey, iv, token, contentType);

          case 25:
            _context.t2 = _context.sent;
            _context.next = 29;
            break;

          case 28:
            _context.t2 = token;

          case 29:
            token = _context.t2;

            if (!(iv && refresh && aesKey)) {
              _context.next = 36;
              break;
            }

            _context.next = 33;
            return EncryptionService.decodeCipher(aesKey, iv, refresh, contentType);

          case 33:
            _context.t3 = _context.sent;
            _context.next = 37;
            break;

          case 36:
            _context.t3 = refresh;

          case 37:
            refresh = _context.t3;

            if (!(token && encryptionService)) {
              _context.next = 41;
              break;
            }

            _context.next = 41;
            return encryptionService.storage.setItem('tokenPat', token);

          case 41:
            if (!(refresh && encryptionService)) {
              _context.next = 44;
              break;
            }

            _context.next = 44;
            return encryptionService.storage.setItem('refreshPat', refresh);

          case 44:
            if (!(keyId && encryptionService)) {
              _context.next = 47;
              break;
            }

            _context.next = 47;
            return encryptionService.storage.setItem('keyId', keyId);

          case 47:
            if (!(status < 200 || status >= 300)) {
              _context.next = 49;
              break;
            }

            throw new HttpError(get(json, 'message', statusText), status, get(json, 'code'), get(json, 'subCodes', []), json);

          case 49:
            _context.t4 = type;
            _context.next = _context.t4 === CREATE ? 52 : _context.t4 === UPLOAD_MANY ? 52 : _context.t4 === UPLOAD ? 52 : _context.t4 === AUTH ? 55 : _context.t4 === DOWNLOAD ? 56 : _context.t4 === GET_ONE ? 57 : 64;
            break;

          case 52:
            if (!token) {
              _context.next = 54;
              break;
            }

            return _context.abrupt("return", {
              data: _objectSpread(_objectSpread({}, json), {}, {
                token: token,
                refresh: refresh,
                keyId: keyId
              }),
              headers: headers
            });

          case 54:
            return _context.abrupt("return", {
              data: _objectSpread(_objectSpread({}, params.data), json),
              headers: headers
            });

          case 55:
            return _context.abrupt("return", {
              data: _objectSpread(_objectSpread({}, json), {}, {
                token: token,
                refresh: refresh
              }),
              headers: headers
            });

          case 56:
            return _context.abrupt("return", {
              data: response,
              headers: headers
            });

          case 57:
            if (!(resource === 'pat/users')) {
              _context.next = 61;
              break;
            }

            token = (_token = token) !== null && _token !== void 0 ? _token : localStorage.getItem('tokenPat');
            refresh = (_refresh = refresh) !== null && _refresh !== void 0 ? _refresh : localStorage.getItem('refreshPat');
            return _context.abrupt("return", {
              data: _objectSpread(_objectSpread({}, json), {}, {
                token: token,
                refresh: refresh
              }),
              headers: headers
            });

          case 61:
            if (!resource.includes('auth/sso/users')) {
              _context.next = 63;
              break;
            }

            return _context.abrupt("return", {
              data: _objectSpread(_objectSpread({}, json), {}, {
                token: token,
                refresh: refresh
              }),
              headers: headers
            });

          case 63:
            return _context.abrupt("return", {
              data: json,
              headers: headers
            });

          case 64:
            return _context.abrupt("return", {
              data: json,
              headers: headers
            });

          case 65:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));

    return function convertHTTPResponse(_x, _x2, _x3, _x4) {
      return _ref.apply(this, arguments);
    };
  }();
  /**
   * @param {string} type Request type, e.g GET_LIST
   * @param {string} resource Resource name, e.g. "posts"
   * @param {Object} params Request parameters. Depends on the request type
   * @param {string} chunkId resource id
   * @param {string} chunkResource Sub resource name
   * @returns {Promise} the Promise for a data response
   */


  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(type, resource, params, chunkId, chunkResource, abortSignal, version, scope) {
      var token, refresh, encryption, publicKey, aesFileEncryptionKey, ivFileEncryptionKey, requestParams, withEncryption, keyId, opts, encryptionOptions, _convertDataRequestTo, url, options, fetchOptions;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            token = params.token, refresh = params.refresh, encryption = params.encryption, publicKey = params.publicKey, aesFileEncryptionKey = params.aesFileEncryptionKey, ivFileEncryptionKey = params.ivFileEncryptionKey, requestParams = _objectWithoutProperties(params, _excluded);
            withEncryption = encryption && encryptionService !== null && ['auth', 'pat'].includes(scope);

            if (!withEncryption) {
              _context2.next = 8;
              break;
            }

            _context2.next = 5;
            return encryptionService.storage.getItem('keyId');

          case 5:
            _context2.t0 = _context2.sent;
            _context2.next = 9;
            break;

          case 8:
            _context2.t0 = null;

          case 9:
            keyId = _context2.t0;
            opts = {
              headers: _objectSpread(_objectSpread(_objectSpread({
                'Content-Type': 'application/json'
              }, token ? {
                Authorization: "Bearer ".concat(token)
              } : {}), refresh ? {
                refresh: refresh
              } : {}), version ? {
                'X-API-VERSION': version
              } : {})
            }; // simple-rest doesn't handle filters on UPDATE route, so we fallback to calling UPDATE n times instead

            if (!(type === UPDATE_MANY)) {
              _context2.next = 13;
              break;
            }

            return _context2.abrupt("return", Promise.all(params.items.map(function (item) {
              return httpClient("".concat(apiUrl, "/").concat(resource, "/").concat(item.id, "?").concat(stringify(params.params)), _objectSpread(_objectSpread({}, opts), {}, {
                method: 'PUT',
                body: JSON.stringify(item),
                signal: abortSignal
              }));
            })).then(concatMultiplesResponses));

          case 13:
            if (!(type === CREATE_MANY)) {
              _context2.next = 15;
              break;
            }

            return _context2.abrupt("return", Promise.all(params.items.map(function (item) {
              return httpClient("".concat(apiUrl, "/").concat(resource, "?").concat(stringify(params.params)), _objectSpread(_objectSpread({}, opts), {}, {
                method: 'POST',
                body: JSON.stringify(item),
                signal: abortSignal
              }));
            })).then(concatMultiplesResponses));

          case 15:
            if (!(type === DELETE_MANY)) {
              _context2.next = 17;
              break;
            }

            return _context2.abrupt("return", Promise.all(params.ids.map(function (id) {
              return httpClient("".concat(apiUrl, "/").concat(resource, "/").concat(id), _objectSpread(_objectSpread({}, opts), {}, {
                method: 'DELETE',
                signal: abortSignal
              }));
            })).then(concatMultiplesResponses));

          case 17:
            encryptionOptions = {
              encryption: encryption,
              publicKey: publicKey,
              aesFileEncryptionKey: aesFileEncryptionKey,
              ivFileEncryptionKey: ivFileEncryptionKey,
              keyId: keyId
            };
            _convertDataRequestTo = convertDataRequestToHTTP(apiUrl, type, resource, requestParams, chunkId, chunkResource), url = _convertDataRequestTo.url, options = _convertDataRequestTo.options;
            fetchOptions = _objectSpread(_objectSpread({}, options), {}, {
              signal: abortSignal,
              headers: _objectSpread(_objectSpread({}, opts.headers), options.headers)
            });

            if (url) {
              _context2.next = 22;
              break;
            }

            return _context2.abrupt("return", Promise.resolve({
              data: {}
            }));

          case 22:
            return _context2.abrupt("return", httpClient(url, _objectSpread(_objectSpread({}, fetchOptions), {}, {
              scope: scope
            }), encryptionOptions).then(function (response) {
              return convertHTTPResponse(response, type, resource, params);
            }).catch(function (error) {
              if (abortSignal && abortSignal.aborted) {
                // eslint-disable-next-line no-console
                return;
              }

              if (process.env.DEBUG) {
                // eslint-disable-next-line no-console
                console.error(error);
                console.error('PARAMS, URL', anonymizeObject(params, ['Authorization', 'refresh', 'token', 'Cookie', 'password']), url);
              }

              throw error;
            }));

          case 23:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));

    return function (_x5, _x6, _x7, _x8, _x9, _x10, _x11, _x12) {
      return _ref2.apply(this, arguments);
    };
  }();
};

export default runQuery;
//# sourceMappingURL=index.js.map